export function readArtworkRuntimeMetadata(asset) {
  const metadata = asset?.metadata?.artwork?.metadata || {};

  return {
    labels: typeof metadata.labels === "string" ? metadata.labels : "",
    enableARTrigger: metadata.enableARTrigger === true
  };
}
